<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <muhasebe-hesap-plani-create-or-update v-model="plan"></muhasebe-hesap-plani-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    :fields="fields"
                    pagination="server"
                    search
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import NetsisOperationsApi from '@/api/netsis-operations';
import { BCard } from 'bootstrap-vue';
import MuhasebeHesapPlaniCreateOrUpdate from './components/MuhasebeHesapPlaniCreateOrUpdate.vue';

export default {
    components:{
        BCard,
        MuhasebeHesapPlaniCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {thClass:'w-20 text-nowrap',name:'Borç/Alacak',key:'BAType'},
                {thClass:'w-20 text-nowrap',name:'Proje Kodu',key:'G_R'},
                {thClass:'w-20 text-nowrap',name:'Yaka',key:'CollarStatusName',tdClass:'text-nowrap'},
                {thClass:'w-20 text-nowrap',name:'Muhasebe Hesap Adı',key:'NetsisAccountNameValue',tdClass:'text-nowrap'},
                {thClass:'w-20 text-nowrap',name:'Muhasebe Hesap Kodu',key:'NetsisAccountCode'},
            ],
            plan:{
                Id:null,
                BAType: null,
                G_R: null,
                CollarStatusId: null,
                NetsisAccountName: null,
                NetsisAccountCode: null
            },
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false
        }
    },  
    methods:{
        provider(data){
            return NetsisOperationsApi.MuhasebePlani.Table(data)
        },
        clearForm(){
            this.editing = false
            this.plan.Id = null
            this.plan.BAType = null
            this.plan.G_R = null
            this.plan.CollarStatusId = null
            this.plan.NetsisAccountName = null
            this.plan.NetsisAccountCode = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.plan.Id = item.Id
            this.plan.BAType = item.BAType
            this.plan.G_R = item.G_R
            this.plan.CollarStatusId = item.CollarStatusId
            this.plan.NetsisAccountName = item.NetsisAccountName
            this.plan.NetsisAccountCode = item.NetsisAccountCode
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            NetsisOperationsApi.MuhasebePlani.CreateOrUpdate(this.editing,this.plan).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem muhasebe hesap planını kaydı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisOperationsApi.MuhasebePlani.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>